var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.sport === 'soccer')?_c('player-page-sport'):_vm._e(),(_vm.sport === 'tennis')?_c('player-page-tennis'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }